/*
 * Click-to-toggle behavior for sections/faq-split.liquid rows. Toggles the
 * `.is-open` class the CSS uses for the grid-template-rows expand/collapse
 * animation and the plus/minus icon, and keeps aria-expanded in sync.
 *
 * Accordion behavior: only one row per section can be open at a time.
 * Opening a row closes any other row already open in that same section.
 */
(function () {
  document.querySelectorAll('.faq-split').forEach(function (section) {
    if (section.hasAttribute('data-faq-split-inited')) return;
    section.setAttribute('data-faq-split-inited', 'true');

    var items = section.querySelectorAll('.faq-item');

    section.querySelectorAll('.faq-item__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var item = trigger.closest('.faq-item');
        if (!item) return;
        var willOpen = !item.classList.contains('is-open');

        items.forEach(function (otherItem) {
          if (otherItem === item) return;
          if (!otherItem.classList.contains('is-open')) return;
          otherItem.classList.remove('is-open');
          var otherTrigger = otherItem.querySelector('.faq-item__trigger');
          if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
        });

        item.classList.toggle('is-open', willOpen);
        trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      });
    });
  });
})();
